// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";

// import { HelmetProvider } from "react-helmet-async";

import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import { useEffect } from "react";
import {PrivateRoute} from './auth';

// Shared pages
import Login from "./cbt_lms/login";
import SignUp from "./cbt_lms/sign_up_student";
import PasswordReset from "./cbt_lms/password_reset";
import PasswordResetForm from "./cbt_lms/change_password";
import Receipt from "./cbt_lms/admin/receipt";
import { QrsCbtPassCodeVerification } from "./cbt_lms/q_code_page";

// Participant pages
import { CbtPassCode } from "./cbt_lms/student/cbt_pass_code";
import { CbtPassCodeVerification } from "./cbt_lms/student/cbt_pass_code_verification";
import CbtQuestion from "./cbt_lms/student/cbt_question";
import TestCompletion from "./cbt_lms/student/TestCompletion";
import StudentProfile from "./cbt_lms/student/studentprofille";
import PrepArenaDashboard from "./cbt_lms/student/PrepArenaDashboard";
import PracticeSession from "./cbt_lms/student/PracticeSession";
import TestResultDetailsPage from "./cbt_lms/student/TestResultDetailsPage";
import ParticipantLogin from './cbt_lms/ParticipantLogin';
import AiSets from './cbt_lms/student/AiSets';
import AiGenerator from "./cbt_lms/student/AiGenerator";
// import SmartGen from './cbt_lms/student/SmartGen';


function App() {

   function ExternalRedirect() {
    useEffect(() => {
      window.location.href = "https://cbthost.com";
    }, []);
    return null;
  }

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>

          {/* Shared Routes */}
          <Route path="/login" element={<ParticipantLogin />} />
           <Route path="*" element={<ExternalRedirect />} />
          {/* <Route path="/login" element={<Login />} /> */}
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/password-reset-form" element={<PasswordResetForm />} />
          <Route path="/qr_verification" element={<QrsCbtPassCodeVerification />} />
          <Route path="/receipt/:reference" element={<Receipt />} />
          <Route path="/sign-up" element={<SignUp />} />

          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Participant Protected */}
          <Route path="/participate" element={<PrivateRoute />}>

            <Route path="dashboard" element={<CbtPassCode />} />
            <Route path="verification" element={<CbtPassCodeVerification />} />
            <Route path="cbt_question" element={<CbtQuestion />} />
            <Route path="test_completion" element={<TestCompletion />} />
            <Route path="profile" element={<StudentProfile />} />

            <Route path="preparena" element={<PrepArenaDashboard />} />
            <Route path="preparena/practice/:setId" element={<PracticeSession />} />
            <Route path="result-details/:internalTestId" element={<TestResultDetailsPage />} />
            {/* <Route path="smartgen" element={<SmartGen />} /> */}
                      <Route path="/participate/smartgen" element={<Navigate to="/participate/ai-generator" replace />} />
            <Route path="ai-sets" element={<AiSets />} />
            <Route path="ai-generator" element={<AiGenerator />} />

          </Route>

        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;